namespace('compass.hotel');

compass.hotel.LowInventoryWarningWidget = compass.defineWidget(function LowInventoryWarningWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = $j.dom.getContext(me);

	var _settings = options;
	var _checkbox = null;

	var _render = me.render = function(widgetElem) {
		if (!_settings.inventoryAvailability || !_settings.meetingInfo.displayLowInvWarning) {
			return;
		}

		var isSoldOut = _settings.inventoryAvailability.is_sold_out;
		var isLowInventory = _settings.inventoryAvailability.is_low_inventory;

		if (isSoldOut) {
			widgetElem.append(_drawSoldOutWarning());
		} else if (isLowInventory) {
			widgetElem.append(_drawLowInventoryWarning());
		}
	};

	var _drawSoldOutWarning = function() {
		return d.div({className: 'lowInventoryWarning soldOutWarning'},
			d.div({className: 'warningIcon'},
				d.span({className: 'icon-warning'})
			),
			d.div({className: 'warningContent'},
				d.h4({className: 'warningTitle'}, 'This room is no longer available.'),
				d.p({className: 'warningMessage'},
					'Another guest may have booked the last available room before your information was submitted. ' +
					'You can save your contact and payment details to use later, or return to the hotel list to select a different room.'
				),
				d.a({className: 'returnToHotelListLink', href: '#'}, 'Return to hotel list').activate(function(e) {
					e.preventDefault();
					me.trigger('LowInventoryWarningWidget.returnToHotelList');
				})
			)
		);
	};

	var _drawLowInventoryWarning = function() {
		return d.div({className: 'lowInventoryWarning lowInventoryNotice'},
			d.div({className: 'warningIcon'},
				d.span({className: 'icon-info'})
			),
			d.div({className: 'warningContent'},
				d.h4({className: 'warningTitle'}, 'Hurry \u2013 limited availability.'),
				d.p({className: 'warningMessage'},
					'This room type is close to selling out. Availability is not guaranteed until your reservation is completed.'
				)
			)
		);
	};

	me.renderCheckboxInto = function(container) {
		_checkbox = d.input({
			type: 'checkbox',
			className: 'soldOutAcknowledgedCheckbox'
		});

		$j(container).append(
			d.div({className: 'soldOutAcknowledgement'},
				d.label({},
					_checkbox,
					d.span({}, ' I understand this room is no longer available and want to save my information without booking.')
				)
			)
		);
	};

	me.isSoldOutAcknowledged = function() {
		if (_checkbox && $j(_checkbox).is(':checked')) {
			return true;
		}
		return false;
	};

	me.isSoldOut = function() {
		return _settings.inventoryAvailability && _settings.inventoryAvailability.is_sold_out;
	};

	me.isDisplayingWarning = function() {
		if (!_settings.inventoryAvailability || !_settings.meetingInfo.displayLowInvWarning) {
			return false;
		}
		return _settings.inventoryAvailability.is_sold_out || _settings.inventoryAvailability.is_low_inventory;
	};

}, {
	WUID: 'defaultLowInventoryWarningWidgetWUID',
	widgetName: 'lowInventoryWarningWidget',
	inventoryAvailability: null,
	meetingInfo: {}
});
